import axios, { AxiosError } from 'axios';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';

import { ILocation } from '../types/location';
import { PositionService } from '../http/position-service';

export default class NodePositionStore {
    private _nodeId: number;
    private _loading = false;
    private _location: ILocation | null = null;

    constructor(nodeId: number = 0) {
        this._nodeId = nodeId;
        makeObservable<NodePositionStore, '_loading' | '_location'>(this, {
            _loading: observable,
            _location: observable,
            loading: computed,
            location: computed,
            load: action,
        });
    }

    get loading(): boolean {
        return this._loading;
    }

    get location(): ILocation | null {
        return this._location;
    }

    async load() {
        runInAction(() => (this._loading = true));
        try {
            const answer = await PositionService.getByNode(this._nodeId);
            runInAction(() => (this._location = answer.data));
        } catch (e) {
            if (axios.isAxiosError(e)) {
                const axError = e as AxiosError;
                if (axError.response?.status === 400) {
                    runInAction(() => (this._location = null));
                }
                // глотаем остальные ошибки, не нужны они нам.
                // else {
                //     throw e;
                // }
            }
        } finally {
            runInAction(() => (this._loading = false));
        }
    }
}
